import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ZoneDropDownDto } from '.';



export class ZoneDropDownResponseModel extends GlobalResponseObject {
    data?: ZoneDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ZoneDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

